<template>
  <div>

    <a-modal
      title="导入提示"
      :visible="exportAlert.visible"
      @ok="closeExportAlertMask"
      :mask="exportAlert.showMask"
      cancelText="取消"
      okText="确认"
      @cancel="closeExportAlertMask"
    >
      <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-row>
          <a-col :md="24" :sm="24">
            <span>数据导入量大时，请到<a href="/icp/task">任务中心</a>查看结果</span>
          </a-col>
          <a-col :md="24" :sm="24">
            <a-progress :percent="percent" :showInfo="true"/>
          </a-col>
          <a-col :md="24" :sm="24">
            <a  :href="fileUrl" v-show="showDownLoad">文件下载</a>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>

</template>
<script>

import request from '../../utils/request'
import {DownLoadApi} from '../../js/DownLoadApi'

export default {
  name: 'importAlert',
  inject: ['reload'],
  data () {
    return {
      form: this.$form.createForm(this, {name: 'import_alert'}),
      fileUrl: '',
      showDownLoad: false,
      percent: 0,
      exportAlert: {
        visible: false,
        showMask: true
      }
    }
  },
  destroyed () {
  },
  created () {
    this.exportAlert.visible = false
    this.exportAlert.showMask = true
  },
  methods: {
    showImportWindow (taskId) {
      for (let i = 0; i < 30; i++) {
        this.sleep(300)
        this.assemblyExportResult(taskId)
      }
    },
    showImportAlertMask () {
      this.percent = 0
      this.exportAlert.visible = true
    },
    closeExportAlertMask () {
      this.exportAlert.visible = false
      this.reload()

    },
    assemblyExportResult (taskId) {
      request({
        url: DownLoadApi.DownLoadUrl.queryExportFileUrl,
        method: 'post',
        params: {
          taskId: taskId
        }
      }).then(response => {
        this.processProcessResult(response)
      })
    },
    processProcessResult (response) {
      var data = response.data
      var realPercent = parseInt(data.model.percent)
      if (data.success) {
        if (realPercent >= 100) {
          this.percent = 100
          if (data.model.fileUrl != '') {
            this.showDownLoad = true
            this.fileUrl = data.model.fileUrl
          }
          return
        }
        if (this.percent < realPercent) {
          this.percent = realPercent
        }
      }
    },
    sleep (sleepTime) {
      for (var start = new Date(); new Date() - start <= sleepTime;) {
      }
    }
  }
}
</script>

<style>
  span {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/message/ImportAlert.vue